<template>
    <v-col cols="12" md="6" class="pl-6">
        <v-row>
            <v-col cols="12" align="start" class="ml-4 color-text text-h5">
                {{ $t('profile.global_progress') }}
            </v-col>
            <v-col cols="12" align="center">
                <v-card
                    class="pa-6"
                    elevation="12"
                    :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?450:280"
                >
                    <v-row justify="center">
                        <v-col cols="12" class="ma-0 pa-0">
                            <v-btn-toggle
                                v-model="rank"
                                tile
                                group
                                borderless
                                mandatory
                                dense
                                @change="changeRank"
                            >
                                <v-btn value="4" class="px-0 mx-2 color-text text-subtitle-1 font-weight-bold" small :disabled="!progressReady">
                                    {{ $t('profile.global_progress_rank[0]') }}
                                </v-btn>
                                <v-btn value="8" class="px-0 mx-2 color-text text-subtitle-1 font-weight-bold" small :disabled="!progressReady">
                                    {{ $t('profile.global_progress_rank[1]') }}
                                </v-btn>
                                <v-btn value="12" class="px-0 mx-2 color-text text-subtitle-1 font-weight-bold" small :disabled="!progressReady">
                                    {{ $t('profile.global_progress_rank[2]') }}
                                </v-btn>
                            </v-btn-toggle>
                        </v-col>
                    </v-row>
                    <v-row class="graph">
                        <v-col v-resize="onResize" id="progress" cols="12" class="progress mt-4 mt-lg-0" v-show="progressReady">
                        </v-col>
                        <v-col cols="12">
                            <v-skeleton-loader
                                width="100%"
                                class="progressSkeleton mt-4 mt-lg-0"
                                type="image"
                                :transition="'scale-transition'"
                                v-show="!progressReady"
                            ></v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-row justify="start" class="desc px-0 mx-0">
                        <v-col cols="12" lg="6" xl="4" class="pa-lg-0">
                            <div style="display: flex;">
                                <span class="dotOne"></span>
                                <span class="px-2 color-text text-subtitle-1">
                                    {{ $t('profile.answered_questions') }}
                                </span>
                            </div>
                        </v-col>
                        <v-col cols="12" lg="6" xl="4" class="pa-lg-0">
                            <div style="display: flex;">
                                <span class="dotTwo"></span>
                                <span class="px-2 color-text text-subtitle-1">
                                    {{ $t('profile.correct_answers') }}
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>

const echarts = require('echarts')

export default {
    props: {
        progress: {
            type: Array
        }
    },
    mounted () {
        this.chart = echarts.init(document.getElementById('progress'))
        this.setChart()
        this.chartReady = true
    },
    data() {
        return {
            allAnswered: [],
            allCorrect: [],
            answered: [],
            correct: [],
            chart: {},
            chartReady: false,
            progressReady: false,
            rank: '4'
        }
    },
    methods: {
        changeRank () {
            this.answered = []
            this.correct = []
            if (this.rank === '12') {
                this.answered = this.allAnswered
                this.correct = this.allCorrect
            }
            if (this.rank === '8') {
                for (let i = 4; i < 12; i+=1) {
                    this.answered.push(this.allAnswered[i])
                    this.correct.push(this.allCorrect[i])
                }
            }
            if (this.rank === '4') {
                for (let i = 8; i < 12; i+=1) {
                    this.answered.push(this.allAnswered[i])
                    this.correct.push(this.allCorrect[i])
                }
            }
            this.setChart()
            this.progressReady = true
        },
        getOption () {
            return {
                grid: {
                    left: '2%',
                    right: '2%',
                    bottom: '2%',
                    top: '2%'
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    show: false
                },
                yAxis: {
                    type: 'value',
                    show: false
                },
                series: [{
                    data: this.answered,
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    areaStyle: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                                {
                                    offset: 0, color: '#DFF8F4'
                                },
                                {
                                    offset: 1, color: 'white'
                                }
                            ],
                            global: false
                        }
                    },
                    lineStyle: {
                        color: '#6AD6C2',
                        width: 5
                    }
                },
                {
                    data: this.correct,
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    lineStyle: {
                        color: '#816AD6',
                        width: 5
                    }
                }]
            }

        },
        onResize () {
            if (this.chartReady) {
                this.chart.resize()
            }
        },
        setChart() {
            this.chart.setOption(this.getOption());
            setTimeout(() => {
                this.onResize()
            }, 10);
        },
        setProgress (data) {
            this.allAnswered = []
            this.allCorrect = []
            data.forEach((item) => {
                this.allAnswered.push(item.totalPreguntas)
                this.allCorrect.push(item.totalCorrectas)
            })
            this.changeRank()
        }
    },
    watch: {
        progress() {
            this.setProgress(this.progress)
        }
    }
}
</script>
<style scoped>
.graph {
    margin-top: -10px;
}
.color-text {
    color: #4A3216;
}
.v-card {
    border-radius: 20px;
}
.v-btn-toggle>.v-btn.v-btn--active {
    border-bottom: 5px solid #FF6F3A;
    color: #4A3216;
    opacity: 1;
}
.v-btn:before {
    background-color: white;
}
.v-btn {
    text-transform: none;
}
.dotOne {
    height: 30px;
    width: 30px;
    background-color: #6AD6C2;
    border-radius: 50%;
    display: inline-block;
}
.dotTwo {
    height: 30px;
    width: 30px;
    background-color: #816AD6;
    border-radius: 50%;
    display: inline-block;
}
.progress {
    width: 100px;
    height: 150px;
}
.progressSkeleton {
    height: 150px;
}
@media (max-width: 1263px) {
    .progress {
        height: 250px;
    }
    .progressSkeleton {
        height: 250px;
    }
}
</style>